import { CSSProperties } from "react";
import { DCol } from "./DCol";
import { DRow } from "./DRow";
import { DText } from "./DText";
import { dcolors } from "corexxx";
import { useDAppCommand } from "./DAppCommand";

export function DTextDashboard({
  item,
  dark,
  itemStyle,
  textStyle,
  valueStyle,
  style,
}: {
  itemStyle?: CSSProperties;
  textStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  style?: CSSProperties;
  item: { text: string; value: string; sub_text?: string }[];
  dark?: boolean;
}) {
  return (
    <DRow style={style}>
      {item.map((it, idx) => (
        <DTextDashboardItem
          key={idx}
          dark={dark}
          text={it.text}
          value={it.value}
          sub_text={it.sub_text}
          itemStyle={{
            background: dcolors.pallets.amber100,
            marginLeft: idx == 0 ? 0 : 10,
            padding: 20,
            ...itemStyle
          }
          }
          textStyle={textStyle}
          valueStyle={valueStyle}
        />
      ))}
    </DRow>
  );
}

export function DTextDashboardItem({
  text,
  value,
  itemStyle,
  textStyle,
  valueStyle,
  sub_text,
  dark,
}: {
  itemStyle?: CSSProperties;
  textStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  text: string;
  value: string;
  sub_text?: string;
  dark?: boolean;
}) {
  let appComamnd = useDAppCommand();
  return (
    <DCol style={{ padding: 0, ...itemStyle }}>
      <DText
        dark={dark}
        style={{
          marginBottom: 0,
          textTransform: "uppercase",
          fontSize: 13.5,
          ...textStyle,
        }}
      >
        {text}
      </DText>
      <DText
        dark={dark}
        style={{ fontSize: 30, fontWeight: "bold", ...valueStyle }}
      >
        {!appComamnd.state.textPrivacyState ? value : "****"}
      </DText>
      {sub_text ? (
        <DText dark={dark} style={{ fontSize: 10, fontWeight: "normal" }}>
          {sub_text}
        </DText>
      ) : null}
    </DCol>
  );
}
